import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function ShopProductDetails() {
    const { id, slug } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [addingToCart, setAddingToCart] = useState(false);
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        const fetchProductDetails = async () => {
            try {
                const response = await axios.get(`https://api.irfanelectricals.com/api/products/${id}`);
                console.log("API Response:", response.data);

                if (!response.data.success) {
                    throw new Error("Invalid product data received");
                }

                setProduct(response.data.product);
            } catch (err) {
                setError("Failed to load product details.");
                console.error("Error fetching product:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchProductDetails();
    }, [id]);

    useEffect(() => {
        if (product && !slug) {
            const newSlug = slugify(product.name);
            window.history.replaceState(null, "", `/product/${id}/${newSlug}`);
        }
    }, [product]);

    const slugify = (text) =>
        text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/(^-|-$)/g, "");

    const handleAddToCart = async () => {
        if (!userId) {
            toast.error("❌ Please log in to add products to the cart.");
            return;
        }

        setAddingToCart(true);

        try {
            const cartResponse = await axios.get(`https://api.irfanelectricals.com/api/cart/${userId}`);
            const cartItems = cartResponse.data.items;

            const productInCart = cartItems.find((item) => item.product_id === product.id);

            if (productInCart) {
                toast.info("ℹ️ Product is already in your cart!");
                setAddingToCart(false);
                return;
            }

            const addToCartResponse = await axios.post(`https://api.irfanelectricals.com/api/cart/${userId}/item`, {
                user_id: userId,
                product_id: product.id,
                quantity: 1,
            });

            console.log("Cart Response:", addToCartResponse.data);

            if (addToCartResponse.status === 200 || addToCartResponse.status === 201) {
                toast.success("✅ Product added to cart!");
            } else {
                toast.error(`❌ Failed: ${addToCartResponse.data.message || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error adding product:", error.response || error);
            toast.error(`❌ API Error: ${error.response?.data?.message || "Network error! Check server."}`);
        } finally {
            setAddingToCart(false);
        }
    };

    if (loading) return <div className="text-center mt-5">Loading product details...</div>;
    if (error) return <div className="text-center text-danger mt-5">{error}</div>;
    if (!product) return <div className="text-center mt-5">Product not found.</div>;

    return (
        <>
            <Helmet>
                <title>{product.name} | Buy Online | Irfan Electricals</title>
                <meta name="description" content={product.description} />
            </Helmet>
            <Navbar />
            <ToastContainer position="top-right" autoClose={2000} />
            <section id="center" className="center_o pt-5 pb-5 bg_light">
                <div className="container-xl">
                    <div className="row center_o1 text-center">
                        <div className="col-md-12">
                            <h1 className="text-uppercase">Product Detail</h1>
                            <h6 className="d-inline-block mb-0 col_yell">
                                <a href="/">Home</a> <span className="mx-2 text-muted">/</span> Product Detail
                            </h6>
                        </div>
                    </div>
                </div>
            </section>

            <section id="detail" className="p_3">
                <div className="container-xl">
                    <div className="row detail_1">
                        <div className="col-md-6">
                            <div className="detail_1l">
                                {product.images && product.images.length > 0 ? (
                                    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                                        <div className="carousel-indicators">
                                            {product.images.map((_, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    data-bs-target="#carouselExampleCaptions"
                                                    data-bs-slide-to={index}
                                                    className={index === 0 ? "active" : ""}
                                                    aria-label={`Slide ${index + 1}`}
                                                />
                                            ))}
                                        </div>
                                        <div className="carousel-inner">
                                            {product.images.map((image, index) => (
                                                <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                                                    <img src={`https://api.irfanelectricals.com/uploads/${image}`} className="d-block w-100" alt={`Product ${index + 1}`} />
                                                </div>
                                            ))}
                                        </div>
                                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true" />
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                ) : (
                                    <p className="text-center">No Images Available</p>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="detail_1r">
                                <h6 className={`d-inline-block text-white font_14 ps-3 pe-3 rounded-1 ${product.stock > 0 ? "bg-success" : "bg-danger"}`}>
                                    {product.stock > 0 ? "In Stock" : "Out of Stock"}
                                </h6>
                                <h4 className="mt-2">{product.name}</h4>

                                <h4 className="mt-3">
                                    <span className="col_yell me-3">${product.price?.toFixed(2)}</span>
                                    {product.originalPrice && (
                                        <span className="font_14 text-decoration-line-through text-muted">${product.originalPrice?.toFixed(2)}</span>
                                    )}
                                </h4>

                                <p><strong>Brand:</strong> {product.brand}</p>
                                <p><strong>HSN Code:</strong> {product.hsn_code}</p>
                                <p><strong>Description:</strong> {product.description}</p>

                                {product.ebay_link && (
                                    <p>
                                        <strong>eBay Link:</strong>{" "}
                                        <a href={product.ebay_link} target="_blank" rel="noopener noreferrer">
                                            {product.ebay_link}
                                        </a>
                                    </p>
                                )}


                                <button className="btn btn-success mt-4 w-100" onClick={handleAddToCart} disabled={addingToCart}>
                                    <i className="fa fa-shopping-cart me-2"></i> {addingToCart ? "Adding..." : "Add to Cart"}
                                </button>

                                <hr />

                                <p className="text-info">
                                    <strong>Lot Stock:</strong> {product.stock !== undefined ? product.stock : "Loading..."}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default ShopProductDetails;
